<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div class="asset-damage-report">
  <div class="filters" *ngIf="data?.filterOptions">
    <div class="kpi">
      <div class="kpi-value">{{ totalDamaged }}</div>
      <div class="kpi-label">DAMAGED</div>
    </div>

    <div class="filter-field filter-field--depot">
      <mat-form-field appearance="fill">
        <mat-label>Depot</mat-label>
        <mat-select multiple [(ngModel)]="selectedDepotIds" (ngModelChange)="onFilterChange()">
          <mat-option *ngFor="let d of data.filterOptions.depots" [value]="d.id">{{ d.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-field">
      <mat-form-field appearance="fill">
        <mat-label>Container</mat-label>
        <mat-select
          multiple
          [(ngModel)]="selectedContainers"
          (ngModelChange)="onLocalFilterChange()"
          (openedChange)="onContainerSelectOpenedChange($event)">
          <div class="select-search-option" (click)="$event.stopPropagation()">
            <input
              #containerSearchInput
              matInput
              placeholder="Search containers"
              [(ngModel)]="containerSearchTerm"
              [ngModelOptions]="{ standalone: true }"
              (click)="$event.stopPropagation()"
              (keydown)="onSearchKeydown($event)">
          </div>
          <mat-option *ngFor="let c of filteredContainerOptions" [value]="c">{{ c }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-field">
      <mat-form-field appearance="fill">
        <mat-label>Status</mat-label>
        <mat-select multiple [(ngModel)]="selectedStatuses" (ngModelChange)="onLocalFilterChange()">
          <mat-option *ngFor="let s of statusOptions" [value]="s">{{ s }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-field filter-field--type">
      <mat-form-field appearance="fill">
        <mat-label>Type</mat-label>
        <mat-select multiple [(ngModel)]="selectedContainerTypes" (ngModelChange)="onFilterChange()">
          <mat-option *ngFor="let t of data.filterOptions.containerTypes" [value]="t">{{ t }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="table-section">
    <div class="table-actions" *ngIf="allRows?.length">
      <button (click)="exportDamageReport()" class="btn btn-white btn-sm">
        Export Data
        <span class="svg-icon svg-icon-xs ms-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Export data</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
        </span>
      </button>
    </div>

    <mat-card *ngIf="!loading">
      <div class="table-wrap" *ngIf="filteredRows?.length">
        <table mat-table [dataSource]="filteredRows" class="mat-elevation-z1">
          <ng-container matColumnDef="depotName">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('depotName')">
              Depot
              <span class="sort-indicator" [ngClass]="getSortDirection('depotName')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ r.depotName }}</td>
          </ng-container>

          <ng-container matColumnDef="assetId">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('assetId')">
              Container
              <span class="sort-indicator" [ngClass]="getSortDirection('assetId')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ getContainerValue(r) }}</td>
          </ng-container>

          <ng-container matColumnDef="assetType">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('assetType')">
              Type
              <span class="sort-indicator" [ngClass]="getSortDirection('assetType')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ r.assetType }}</td>
          </ng-container>

          <ng-container matColumnDef="locationName">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('locationName')">
              Location
              <span class="sort-indicator" [ngClass]="getSortDirection('locationName')"></span>
            </th>
            <td mat-cell *matCellDef="let r" class="location-cell">{{ r.locationName }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('status')">
              Status
              <span class="sort-indicator" [ngClass]="getSortDirection('status')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ r.status }}</td>
          </ng-container>

          <ng-container matColumnDef="fault">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('fault')">
              Fault
              <span class="sort-indicator" [ngClass]="getSortDirection('fault')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ r.fault }}</td>
          </ng-container>

          <ng-container matColumnDef="reportedDate">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('reportedDate')">
              Reported
              <span class="sort-indicator" [ngClass]="getSortDirection('reportedDate')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ formatDate(r.reportedDate) || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="reportedBy">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('reportedBy')">
              By
              <span class="sort-indicator" [ngClass]="getSortDirection('reportedBy')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ r.reportedBy }}</td>
          </ng-container>

          <ng-container matColumnDef="assessmentDate">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('assessmentDate')">
              Assessment
              <span class="sort-indicator" [ngClass]="getSortDirection('assessmentDate')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ formatDate(r.assessmentDate) || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="vorTime">
            <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('vorTime')">
              VOR Time
              <span class="sort-indicator" [ngClass]="getSortDirection('vorTime')"></span>
            </th>
            <td mat-cell *matCellDef="let r">{{ formatVorTime(r.vorTime) || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef>Details</th>
            <td mat-cell *matCellDef="let r">
              <a *ngIf="getDamageDetailsUrl(r) as detailsUrl" class="mini-link" [href]="detailsUrl" target="_blank" rel="noopener" aria-label="Damage details">&#128279;</a>
            </td>
          </ng-container>

          <ng-container matColumnDef="rowAction">
            <th mat-header-cell *matHeaderCellDef class="row-action-header"></th>
            <td mat-cell *matCellDef="let r" class="row-action-cell">
              <button
                *ngIf="selectedRow === r"
                (click)="goToMoreInfo(r); $event.stopPropagation()"
                class="btn btn-sm more-info-btn more-info-btn--active">
                More Info
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns;"
            class="data-row"
            [class.row-selected]="selectedRow === row"
            (click)="onRowClick(row)"
            (dblclick)="onRowDoubleClick(row)">
          </tr>
        </table>
      </div>

      <div *ngIf="!filteredRows?.length" class="empty"></div>
    </mat-card>
  </div>
</div>
